import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  ArrowClockwise,
  ArrowLeft,
  ArrowRight,
  ChevronLeft,
  ChevronRight,
} from "react-bootstrap-icons";
import { useNavigate } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import { ApiConnectionString } from "../../constants/ApiConntection";
import LoadingSpinner from "../../components/LoadingSpinner";
import MyDynamicClassModal from "./modals/MyDynamicClassModal";
import ConfirmCancelRequestModal from "./modals/ConfirmCancelRequestModal";
import RefuseCancelRequestModal from "./modals/RefuseCancelRequestModal";

export default function BookingsAndShedule({ id }) {
  const [monday, setMonday] = useState([]);
  const [tuesday, setTuesday] = useState([]);
  const [wednesday, setWednesday] = useState([]);
  const [thursday, setThursday] = useState([]);
  const [friday, setFriday] = useState([]);
  const [saturday, setSaturday] = useState([]);
  const [sunday, setSunday] = useState([]);
  const [mondayDate, setMondayDate] = useState("");
  const [tuesdayDate, setTuesdayDate] = useState("");
  const [wednesdayDate, setWednesdayDate] = useState("");
  const [thursdayDate, setThursdayDate] = useState("");
  const [fridayDate, setFridayDate] = useState("");
  const [saturdayDate, setSaturdayDate] = useState("");
  const [sundayDate, setSundayDate] = useState("");
  const [routineClasses, setRoutineClasses] = useState([]);
  const [oneOffClasses, setOneOffClasses] = useState([]);
  const [cancelClassModalActive, setCancelClassModalActive] = useState(false);
  const [pastClasses, setPastClasses] = useState([]);
  const [bookings, setBookings] = useState([]);
  const [futureClasses, setFutureClasses] = useState([]);
  const [currentDateTime, setCurrentDateTime] = useState(new Date());
  const [events, setEvents] = useState([]);
  const [today, setToday] = useState(new Date());
  const { user,dispatch } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const [selectedDynamicClass, setSelectedDynamicClass] = useState(null);
  const [dynamicClassModal, setDynamicClassModal] = useState(false);
  const [cancelRequests, setCancelRequests] = useState([]);
  const [selectedCancelRequest, setSelectedCancelRequest] = useState(null);
  const [confirmCancelRequestModal, setConfirmCancelRequestModal] =
    useState(false);
  const [refuseCancelRequestModal, setRefuseCancelRequestModal] =
    useState(false);
  const [mondayDateNoFormat, setMondayDateNoFormat] = useState("");
  const [tuesdayDateNoFormat, setTuesdayDateNoFormat] = useState("");
  const [wednesdayDateNoFormat, setWednesdayDateNoFormat] = useState("");
  const [thursdayDateNoFormat, setThursdayDateNoFormat] = useState("");
  const [fridayDateNoFormat, setFridayDateNoFormat] = useState("");
  const [saturdayDateNoFormat, setSaturdayDateNoFormat] = useState("");
  const [sundayDateNoFormat, setSundayDateNoFormat] = useState("");
  const cancelModal = () => {
    setDynamicClassModal(false);
    setConfirmCancelRequestModal(false);
    setRefuseCancelRequestModal(false);
  };

  const fetchData = async () => {
    setIsLoading(true);
    try {
      // const currentDate = today;
      // await setToday(currentDate);

      // Fetch one-off classes
      const cancelRequestResponse = await axios.get(
        `${ApiConnectionString}/api/GetAllCancelRequests/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (cancelRequestResponse.status === 200) {
        setCancelRequests(cancelRequestResponse.data);
      }

      const oneOffClassResponse = await axios.get(
        `${ApiConnectionString}/api/OneoffEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (oneOffClassResponse.status === 200) {
        setOneOffClasses(oneOffClassResponse.data);
      }

      // Fetch routine classes
      const routineClassResponse = await axios.get(
        `${ApiConnectionString}/api/RoutineEventsByClub/${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (routineClassResponse.status === 200) {
        setRoutineClasses(routineClassResponse.data);
      }

      // Fetch bookings
      const bookingResponse = await axios.get(
        `${ApiConnectionString}/api/Bookings?OwnerId=${user.id}&ClubId=${id}`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );
      if (bookingResponse.status === 200) {
        setBookings(bookingResponse.data);
      }
    } catch (error) {
      if (error.status == 401) {
        dispatch({ type: "LOGOUT" });
        navi("/");
      }
      console.error("Error fetching club data:", error);
      // Optionally, handle the error by setting an error state or notifying the user
    } finally {
      // Ensure loading state is reset
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let timeout;

    if (user) {
      fetchData();
    } else {
      timeout = setTimeout(() => {
        dispatch({ type: "LOGOUT" });
        navi("/");
        // Add your fallback logic here
      }, 3000); // Delay of 3 seconds before executing the else logic
    }

    return () => clearTimeout(timeout);
  }, [today, dynamicClassModal, id,user]);

  useEffect(() => {
    const past = oneOffClasses.filter(
      (cls) => new Date(cls.oneOffDate) < today
    );
    const future = oneOffClasses.filter(
      (cls) => new Date(cls.oneOffDate) >= today
    );

    setPastClasses(past);
    setFutureClasses(future);
  }, [oneOffClasses, id,user]);

  const navi = useNavigate();
  const addOneWeek = () => {
    setCurrentDateTime((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + 7);
      return newDate;
    });
  };
  const minusOneWeek = () => {
    setCurrentDateTime((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() - 7);
      return newDate;
    });
  };

  // Function to group routineClasses by day
  const groupClassesByDay = () => {
    // Define the order of days
    const daysOfWeek = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];
    const groupedClasses = {};

    // Initialize groupedClasses with empty arrays for each day
    daysOfWeek.forEach((day) => (groupedClasses[day] = []));

    // Populate groupedClasses with routineClasses data
    routineClasses.forEach((classItem) => {
      const { day, ...rest } = classItem;
      if (groupedClasses[day]) {
        groupedClasses[day].push(rest);
      }
    });

    return groupedClasses;
  };

  // Grouped routineClasses by day
  const groupedByDay = groupClassesByDay();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [bookingResponse, eventResponse] = await Promise.all([
          axios.get(
            `${ApiConnectionString}/api/Bookings?&ClubId=${id}&FromDateTime=${getDateTime()}&weekly=true`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          ),

          axios.get(
            `${ApiConnectionString}/api/events?ClubId=${id}&FromDateTime=${getDateTime()}&ownerId=${
              user.id
            }`,
            {
              headers: { Authorization: `Bearer ${user.token}` },
            }
          ),
        ]);

        const bookings = bookingResponse.data;
        const events = eventResponse.data;

        const updatedEvents = events.map((event) => ({
          ...event,
          booked: bookings.some(
            (booking) =>
              booking.eventId === event.id && booking.date === event.oneOffDate
          ),
        }));

        setBookings(bookings);
        setEvents(updatedEvents);
      } catch (error) {
        if (error.status == 401) {
          dispatch({ type: "LOGOUT" });
          navi("/");
        }
        console.error("Error fetching data:", error);
      }
    };

    const getWeekDates = (currentDate) => {
      const monday = new Date(currentDate);
      const day = monday.getDay();
      const diffToMonday = (day === 0 ? -6 : 1) - day; // Adjust if the current day is Sunday
      monday.setDate(monday.getDate() + diffToMonday);

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(monday);
        date.setDate(monday.getDate() + i);
        return date.toLocaleDateString();
      });
    };

    fetchData();

    const [mon, tue, wed, thu, fri, sat, sun] = getWeekDates(
      new Date(currentDateTime)
    );

    setMondayDate(mon);
    setTuesdayDate(tue);
    setWednesdayDate(wed);
    setThursdayDate(thu);
    setFridayDate(fri);
    setSaturdayDate(sat);
    setSundayDate(sun);
  }, [currentDateTime, cancelClassModalActive, id, dynamicClassModal,user]);
  useEffect(() => {
    const getWeekDates = (currentDate) => {
      const monday = new Date(currentDate);
      const day = monday.getDay();
      const diffToMonday = (day === 0 ? -6 : 1) - day; // Adjust if the current day is Sunday
      monday.setDate(monday.getDate() + diffToMonday);

      return Array.from({ length: 7 }, (_, i) => {
        const date = new Date(monday);
        date.setDate(monday.getDate() + i);
        date.setHours(23, 59, 0, 0); // Set time to 23:59
        return date;
      });
    };

    fetchData();

    const [mon, tue, wed, thu, fri, sat, sun] = getWeekDates(
      new Date(currentDateTime)
    );

    setMondayDateNoFormat(mon);
    setTuesdayDateNoFormat(tue);
    setWednesdayDateNoFormat(wed);
    setThursdayDateNoFormat(thu);
    setFridayDateNoFormat(fri);
    setSaturdayDateNoFormat(sat);
    setSundayDateNoFormat(sun);
  }, [currentDateTime, id,user]);

  const getDateTime = () => {
    const now = currentDateTime;
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  useEffect(() => {
    const sortByTimeIn = (a, b) => a.timeIn - b.timeIn;
  
    setMonday(events.filter((event) => event.day === "Monday").sort(sortByTimeIn));
    setTuesday(events.filter((event) => event.day === "Tuesday").sort(sortByTimeIn));
    setWednesday(events.filter((event) => event.day === "Wednesday").sort(sortByTimeIn));
    setThursday(events.filter((event) => event.day === "Thursday").sort(sortByTimeIn));
    setFriday(events.filter((event) => event.day === "Friday").sort(sortByTimeIn));
    setSaturday(events.filter((event) => event.day === "Saturday").sort(sortByTimeIn));
    setSunday(events.filter((event) => event.day === "Sunday").sort(sortByTimeIn));
  }, [events, id,user]);

  if (isLoading) {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  } else {
    return (
      <div className="row">
           <div className="lightBlueBanner">
          <p className="fw-bold p-2">Booking and Schedule</p>
        </div>
        <div className="col-12 text-center">
          <div className="container mt-4">
    {cancelRequests.length > 0 &&        <div className="row">
      <p className="red-text fw-bold">The following people wish to cancel their bookings.</p>

              {cancelRequests.map((request) => (
                <div className="col-md-4" key={request.id}>
                  <div className="card mb-4">
                    <div className="card-body">
                      <h5 className="card-title">
                        {request.viewBookingProfile.firstName}{" "}
                        {request.viewBookingProfile.lastName}
                      </h5>
                      <p className="text-muted">
                     
                        {new Date(request.date).toLocaleDateString()}
                      </p>
                      <p className="card-text">
                        <strong>Class:</strong> {request.viewEvent.name} at{" "}
                        {request.viewEvent.timeIn} - {request.viewEvent.timeOut}
                      </p>
                      <div className="d-flex justify-content-between">
                        <button
                          onClick={() => {
                            setSelectedCancelRequest(request);
                            setConfirmCancelRequestModal(true);
                          }}
                          className="saveChanges-button"
                        >
                          Confirm
                        </button>
                        <button
                          onClick={() => {
                            setSelectedCancelRequest(request);
                            setRefuseCancelRequestModal(true);
                          }}
                          className="delete-button"
                        >
                          Refuse
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>}
          </div>
          <div>
            <div className="customNav row mx-2">
              <div className="col mt-2">
                <p className="fw-bold fontSize20">Classes</p>
              </div>
              <div className="col mt-3">
                <p>
                  {mondayDate} - {sundayDate}
                </p>
              </div>
              <div className="col d-flex justify-content-end mt-3">
                <div
                  className="d-flex mx-3 cursor-pointer"
                  onClick={() => minusOneWeek()}
                >
                  <ChevronLeft className="mt-1" />
                  <p>Previous</p>
                </div>
                <div
                  className="d-flex cursor-pointer"
                  onClick={() => addOneWeek()}
                >
                  <p>Next</p>
                  <ChevronRight className="mt-1" />
                </div>
              </div>
            </div>

            {events.length == 0 &&   <div className="text-center" ><p className="fw-bold">No classes are on this week.</p></div>}

            <div className="row timetable mx-5">
              <div
                className={`col p-0 ${monday.length == 0 ? "noClasses" : ""} ${
                  mondayDateNoFormat < today ? "opacity-50" : ""
                }`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5"> Monday</p>
                    <p className="mb-0">{mondayDate}</p>
                  </div>

                  {monday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${tuesday.length == 0 ? "noClasses" : ""} ${
                  tuesdayDateNoFormat < today ? "opacity-50" : ""
                }`}
              >
                <div className="">
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5"> Tuesday</p>
                    <p className="mb-0">{tuesdayDate}</p>
                  </div>

                  {tuesday.map((activity) => (
                    <div
                      className="classes-container "
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${
                  wednesday.length == 0 ? "noClasses" : ""
                } ${wednesdayDateNoFormat < today ? "opacity-50" : ""}`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5">Wednesday</p>
                    <p className="mb-0">{wednesdayDate}</p>
                  </div>

                  {wednesday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${
                  thursday.length == 0 ? "noClasses" : ""
                } ${thursdayDateNoFormat < today ? "opacity-50" : ""}`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5">Thursday</p>
                    <p className="mb-0">{thursdayDate}</p>
                  </div>

                  {thursday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${friday.length == 0 ? "noClasses" : ""} ${
                  fridayDateNoFormat < today ? "opacity-50" : ""
                }`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5">Friday</p>
                    <p className="mb-0">{fridayDate}</p>
                  </div>

                  {friday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${
                  saturday.length == 0 ? "noClasses" : ""
                } ${saturdayDateNoFormat < today ? "opacity-50" : ""}`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5">Saturday</p>
                    <p className="mb-0">{saturdayDate}</p>
                  </div>

                  {saturday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center ">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className={`col p-0 ${sunday.length == 0 ? "noClasses" : ""} ${
                  sundayDateNoFormat < today ? "opacity-50" : ""
                }`}
              >
                <div>
                  <div className="timetable-wkday text-center rounded-top">
                    <p className="px-5">Sunday</p>
                    <p className="mb-0">{sundayDate}</p>
                  </div>

                  {sunday.map((activity) => (
                    <div
                      className="classes-container"
                      key={activity.id}
                      onClick={() => {
                        setSelectedDynamicClass(activity);
                        setDynamicClassModal(true);
                      }}
                    >
                      <div className="class-content text-center">
                        <p className="fontSize20">{activity.name}</p>
                        <p className="fontSize12">{activity.description}</p>
                        <p className="fontSize14">
                            Time in:{" "}
                            {`${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeIn)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                          <p className="fontSize14">
                            Time out:{" "}
                            {`${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(0, 2)}:${String(activity.timeOut)
                              .padStart(4, "0")
                              .slice(2)}`}
                          </p>
                        {activity.bookingCapacity - activity.bookedCount >
                          0 && (
                          <p>
                            Spaces left:{" "}
                            {activity.bookingCapacity - activity.bookedCount}
                          </p>
                        )}
                        <p>Booked: {activity.bookedCount}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>

        {dynamicClassModal && (
          <MyDynamicClassModal
            event={selectedDynamicClass}
            cancelModal={cancelModal}
          />
        )}
        {confirmCancelRequestModal && (
          <ConfirmCancelRequestModal
            cancelModal={cancelModal}
            request={selectedCancelRequest}
            fetchData={fetchData}
          />
        )}
        {refuseCancelRequestModal && (
          <RefuseCancelRequestModal
            cancelModal={cancelModal}
            request={selectedCancelRequest}
            fetchData={fetchData}
          />
        )}
      </div>
    );
  }
}
